import { ProviderFeatureKey } from '../graphQlTypes.generated';

/**
 * Feature keys requested on {@link GetRoomForPatient} for patient surfaces so
 * plan and branding entitlements resolve in one round trip (see `providerEntitlements`).
 */
export const PATIENT_ROOM_FEATURE_KEYS: ProviderFeatureKey[] = [
  ProviderFeatureKey.ProPlan,
  ProviderFeatureKey.PremiumPlan,
  ProviderFeatureKey.Branding,
];
